<template>
  <div class="a4-page">
    <div class="d-flex flex-column h-full">
      <ticket-details
        :party="party"
        :ticket="ticket"
        :user="user"
        :images="images"
        class="mb-3"
        :bgColor="bgColor"
        :share="share"
      />
      <v-card :color="bgColor" class="rounded-xl pa-4 pb-3" elevation="0">
        <party-details
          :party="party"
          :images="images"
          :fullAddress="fullAddress"
          :geometry="geometry"
        />
        <v-divider v-if="fullAddress" class="my-3" />
        <party-address
          :party="party"
          :images="images"
          :fullAddress="fullAddress"
          :geometry="geometry"
        />
      </v-card>
      <v-spacer />
      <div class="d-flex align-center mb-4 gap-2">
        <svg height="2" style="flex: 1">
          <line
            x1="0"
            y1="0"
            x2="100%"
            y2="0"
            stroke="black"
            stroke-width="4"
            stroke-dasharray="14 8 "
          />
        </svg>
        <small class="flex-shrink-0">
          Esse canhoto pode ser recolhido na entrada do evento
        </small>
        <svg height="2" style="flex: 1">
          <line
            x1="0"
            y1="0"
            x2="100%"
            y2="0"
            stroke="black"
            stroke-width="4"
            stroke-dasharray="14 8 "
          />
        </svg>
      </div>
      <ticket-details
        :party="party"
        :ticket="ticket"
        :user="user"
        :images="images"
        secondary
        :share="share"
      />

      <div class="d-flex w-full black--text">
        <small> Arquivo gerado em {{ new Date().toLocaleString() }} </small>
        <v-spacer />
        <div v-if="!hidePoweredBy" class="d-flex align-center justify-center">
          <small class="mr-2 lh-1">PoweredBy</small>
          <img height="14" src="/img/logo/tiqone-black.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import PartyDetails from "@/components/app/myTickets/ExportPartyDetails.vue";
import PartyAddress from "@/components/app/myTickets/ExportPartyAddress.vue";
import { hidePoweredBy } from "@/themeConfig.js";
import TicketDetails from "@/components/app/myTickets/ExportTicketDetails.vue";

export default {
  components: {
    QrcodeVue,
    PartyDetails,
    PartyAddress,
    TicketDetails,
  },
  props: {
    ticket: Object,
    currentIndex: Number,
    user: Object,
    images: Object,
    party: Object,
    fullAddress: String,
    geometry: Object,
    share: Object,
  },
  data: () => ({
    hidePoweredBy,
    bgColor: "#e5e5e5",
  }),
};
</script>

<style>
.a4-page {
  width: 210mm;
  height: 295mm;
  /* border: 1px solid #e0e0e0; */
  padding: 7mm 7mm 3mm;
  background-color: #fff;
}
</style>
